import React from 'react';
import {
  InstantSearch as ReactInstantSearch,
  InstantSearchProps as ReactInstantSearchProps,
} from 'react-instantsearch-hooks';
import InsightsMiddleware from './middlewares/InsightsMiddleware';
import { searchClient } from '@/algolia/searchClient';

const InstantSearch: React.FC<Partial<ReactInstantSearchProps>> = ({ indexName, children, ...props }) => (
  <ReactInstantSearch searchClient={searchClient} indexName={indexName as string} {...props}>
    <InsightsMiddleware />
    {children}
  </ReactInstantSearch>
);

export default InstantSearch;
